import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from "react-redux";
import CloseButton from './CloseButton';

import SCROLL_MODAL_SETTINGS from '../../styles/modalSettings';

// SASS Imports
require('./Modal.scss');

class BaseModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let classNames = "modalPanel";
        if(this.props.containerClass) {
            classNames += ` ${this.props.containerClass}`;
        }
        return (
            <Modal
                ariaHideApp={false}
                isOpen={this.props.isOpen}
                onRequestClose={this.props.onRequestClose}
                onAfterOpen= {this.props.onAfterOpen}
                shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
                contentLabel="Modal"
                style={{...SCROLL_MODAL_SETTINGS, ...this.props.style}}>
                <div className={classNames}>
                    {this.props.hasCloseButton && <button className="close" onClick={this.props.onRequestClose}>
                            <CloseButton />
                    </button>}
                    <div className="modalWrap">
                        {this.props.renderWithHeader && <div className="modalHeader text-center"><h4>{ this.props.title }</h4></div>}
                        {this.props.renderWithHeader ? <div className="modalContent">{React.Children.toArray(this.props.children)}</div>
                        : React.Children.toArray(this.props.children) }
                    </div>
                </div>
            </Modal>
        );
    }
}

BaseModal.defaultProps = {
    isOpen: false,
    renderWithHeader: true,
    containerClass: 'defaultModal',
    hasCloseButton: true,
    shouldCloseOnOverlayClick: true
};


export default BaseModal;



// WEBPACK FOOTER //
// ./app/components/Modals/BaseModal.jsx